<template>
<div class="toast-container position-fixed bottom-0 end-0 p-3">
  <div ref="liveToast" :class="success == true ? 'toast success':'toast failed'" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header">
      <strong class="me-auto">{{success == true ? 'Success':'Failed'}}</strong>
      <button type="button" class="btn btn-default toast-btn" data-bs-dismiss="toast">
        <CloseIcon/>
      </button>
    </div>
    <div class="toast-body">
      {{ message }}
    </div>
  </div>
</div>
</template>
<script>
import { Toast } from 'bootstrap';
import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
    components:{
        CloseIcon
    },
    props:{
        message:{
            type: String,
            required: true,
        },
        success:{
            type: Boolean,
            required: true
        }
    },
    data(){
        return{
            toastInstance: null
        }
    },
    mounted(){
        this.toastInstance = new Toast(this.$refs.liveToast, { delay: 3000, autohide: true });
    },
    methods:{
        show(){
            this.toastInstance.show();
        },
        hide(){
            this.toastInstance.hide();
        }
    }
}
</script>
<style scoped>


 .toast-btn{
      transform:translate(1rem,-0.1rem);
      color:var(--toast-text);     
    }

.toast-btn:hover{
      border:0px;
    }

    .toast-header{
        border-bottom:0px;
        background:transparent;
        color:var(--toast-text);
        height:2rem;
    }

    .toast{
        backdrop-filter: blur(2px);
        color:var(--toast-text);
        border-radius:8px;

    }

    .success{
        background:var(--toast-success);
        border:1px solid var(--succes-outline);
    }

    .failed{
        background:var(--toast-failed);
        border:1px solid var(--failed-outline);
    }
</style>